<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-bottom-transition"
    :max-width="currentWidth"
    :persistent="true"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    eager
  >
    <template v-slot:activator="{ on }">
      <v-list dense>

      <v-list-item v-on="on">
        <v-list-item-avatar>
          <v-icon color="info">fal fa-plus</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title style="cursor:pointer;" class="info--text">
            Add a card
          </v-list-item-title>
        </v-list-item-content>

        <v-list-item-action> </v-list-item-action>
      </v-list-item>
        </v-list>
    </template>


        <v-card :height="modalHeight">
          <v-toolbar flat color="white">
            <v-toolbar-title color="primary--text">Add a card</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon text @click="dialog = false" color="primary">
                <v-icon>fal fa-times</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-alert :value="error" color="error" outlined>
              {{ paymentErrorMessage }}
            </v-alert>
            <v-row row wrap class="">
              <v-col cols="12" class="field">
                <div
                  id="card-element-card-number"
                  class="stripeInput empty"
                ></div>
                <label for="card-element-card-number">Card number</label>
                <div class="baseline"></div>
              </v-col>
            </v-row>

            <v-row row class="mt-2">
              <v-col cols="6" class="field">
                <div id="card-element-expiry" class="stripeInput empty"></div>
                <label for="card-element-expiry">Expiry Date</label>
                <div class="baseline"></div>
              </v-col>

              <v-col cols="6" class="field">
                <div id="card-element-cvc" class="stripeInput empty"></div>
                <label for="card-element-cvc">CVC</label>
                <div class="baseline"></div>
              </v-col>
            </v-row>

          </v-card-text>

          <v-card-actions>
            <v-btn
              :loading="globalLoading"
              block
              color="info"
              :disabled="disabled"
              @click.prevent="addNewCard"
            >
              ADD NEW CARD
            </v-btn>
          </v-card-actions>

          <!--           <div
            style="position:sticky; bottom:0; padding: 12px; background: #fafafa;width: 100%"
          >
            <v-btn
              block
              color="info"
              :disabled="disabled"
              @click.prevent="addNewCard"
            >
              ADD NEW CARD
            </v-btn>
          </div> -->
        </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      dialog: false,
      stripe: {},
      card: {
        cardNumber: '',
        expiry: '',
        cvc: '',
      },
      error: false,
      paymentErrorMessage: '',
      adding: false,
      loading: true,
    };
  },
  methods: {
    async addNewCard() {
      this.adding = true;
      const card = this.card.cardNumber;
      // const { token, error } = await this.stripe.createToken(card);
      const { paymentMethod, error } = await this.stripe.createPaymentMethod({
        type: 'card',
        card,
      });
      const response = await this.$store.dispatch('ADD_NEW_CARD', {
        paymentMethod,
      });
      this.$store.commit('SET_SELECTED_CARD', this.savedCards[0]);
      this.closeModal();
      this.resetModal();
      this.adding = false;
    },

    stripeCardInit() {
      this.loading = true;
      const elements = this.stripe.elements();
      const style = {
        base: {
          color: '#002a3f', // cfkDarkBlue
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          ':-webkit-autofill': {
            color: '#002a3f',
          },
          '::placeholder': {
            color: '#CFD7DF',
          },

          fontSize: '18px',
          fontWeight: '500',
        },
        invalid: {
          color: '#da3f3f', // cfk alert
          iconColor: '#da3f3f',
        },
      };

      const elementClasses = {
        focus: 'focused',
        empty: 'empty',
        invalid: 'invalid',
      };

      // Create an instance of the card Element.
      // this.card = elements.create("card", { style, hidePostalCode: true });

      this.card.cardNumber = elements.create('cardNumber', {
        style,
        classes: elementClasses,
      });
      this.card.cardNumber.mount('#card-element-card-number');

      this.card.expiry = elements.create('cardExpiry', {
        style,
        classes: elementClasses,
      });
      this.card.expiry.mount('#card-element-expiry');

      this.card.cvc = elements.create('cardCvc', {
        style,
        classes: elementClasses,
      });
      this.card.cvc.mount('#card-element-cvc');

      this.loading = false;
    },

    setUpInputs() {
      const inputs = document.querySelectorAll('.stripeInput');
      Array.prototype.forEach.call(inputs, (input) => {
        input.addEventListener('focus', () => {
          input.classList.add('focused');
        });
        input.addEventListener('blur', () => {
          input.classList.remove('focused');
        });
        input.addEventListener('keyup', () => {
          if (input.value.length === 0) {
            input.classList.add('empty');
          } else {
            input.classList.remove('empty');
          }
        });
      });
    },
    closeModal() {
      this.dialog = false;
    },

    resetModal() {
      for (const key in this.card) {
        this.card[key].clear();
      }
    },

    mountCard() {
      Object.values(this.card).forEach((element) => {
        element.addEventListener('change', ({ error }) => {
          if (error) {
            this.error = true;
            this.paymentErrorMessage = error.message;
          } else {
            this.error = false;
            this.paymentErrorMessage = '';
          }
        });
      });
    },
  },

  computed: {
    ...mapGetters(['parent', 'snackbar', 'stripePublicKey', 'globalLoading', 'savedCards']),
    currentWidth() {
      return 480;
    },
    modalHeight() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return '100vh';
      }
      return '100%';
    },

    disabled() {
      return this.cardFormNotFilledIn || this.error || this.adding;
    },

    cardFormNotFilledIn() {
      return (
        !this.card.cardNumber._complete
        || !this.card.expiry._complete
        || !this.card.cvc._complete
      );
    },
  },
  components: {},
  mounted() {
    this.stripe = Stripe(this.$store.getters.stripePublicKey);
    this.stripeCardInit();
    this.setUpInputs();
    this.mountCard();

    Array.prototype.forEach.call(
      document.querySelectorAll(
        "input[type='text'], input[type='email'], input[type='tel']",
      ),
      (input) => {
        input.removeAttribute('disabled');
      },
    );
  },
};
</script>

<style scoped lang="scss">
.stripe-error-message {
  justify-content: center;
  align-items: center;
  display: grid;
  color: #fa755a;
}

.card-label {
  display: grid;
  grid-template-rows: 1fr;
  grid-column-gap: 16px;
}

/* Add Animation */
@-webkit-keyframes slideIn {
  from {
    bottom: -300px;
    opacity: 0;
  }
  to {
    bottom: 0;
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    bottom: -300px;
    opacity: 0;
  }
  to {
    bottom: 0;
    opacity: 1;
  }
}

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.field {
  position: relative;
  // width: 100%;
  height: 50px;
  margin: 0 10px;
}

.baseline {
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  bottom: 0;
  background-color: #cfd7df;
  transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

label {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 8px;
  color: #cfd7df;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transform-origin: 0 50%;
  cursor: text;
  transition-property: color, transform;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripeInput {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  padding-bottom: 7px;
  color: #32325d;
  background-color: transparent;
}

.stripeInput::-webkit-input-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripeInput::-moz-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripeInput:-ms-input-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripeInput.StripeElement {
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  will-change: opacity;
}

.stripeInput.focused,
.stripeInput:not(.empty) {
  opacity: 1;
}

.stripeInput.focused::-webkit-input-placeholder,
.stripeInput:not(.empty)::-webkit-input-placeholder {
  color: #cfd7df;
}

.stripeInput.focused::-moz-placeholder,
.stripeInput:not(.empty)::-moz-placeholder {
  color: #cfd7df;
}

.stripeInput.focused:-ms-input-placeholder,
.stripeInput:not(.empty):-ms-input-placeholder {
  color: #cfd7df;
}

.stripeInput.focused + label,
.stripeInput:not(.empty) + label {
  color: #aab7c4;
  transform: scale(0.85) translateY(-25px);
  cursor: default;
}

.stripeInput.focused + label {
  color: #24b47e;
}

.stripeInput.invalid + label {
  color: #ffa27b;
}

.stripeInput.focused + label + .baseline {
  background-color: #24b47e;
}

.stripeInput.focused.invalid + label + .baseline {
  background-color: #e25950;
}

input,
button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  border-style: none;
}

input:-webkit-autofill {
  -webkit-text-fill-color: #002a3f;
  transition: background-color 100000000s;
  -webkit-animation: 1ms void-animation-out;
}

.StripeElement--webkit-autofill {
  background: transparent !important;
}

input,
button {
  -webkit-animation: 1ms void-animation-out;
}

input:active {
  background-color: #159570;
}

.error svg {
  margin-top: 0 !important;
}

.error svg .base {
  fill: #e25950;
}

.error svg .glyph {
  fill: #fff;
}

.error .message {
  color: #e25950;
}

.success .icon .border {
  stroke: #abe9d2;
}

.success .icon .checkmark {
  stroke: #24b47e;
}

.success .title {
  color: #32325d;
  font-size: 16px !important;
}

.success .message {
  color: #8898aa;
  font-size: 13px !important;
}

.success .reset path {
  fill: #24b47e;
}

.bottom-nav {
  display: grid;
  align-items: center;
  position: sticky;
  position: -webkit-sticky;
  position: -moz-sticky;
  position: -ms-sticky;
  position: -o-sticky;
  bottom: 0;
  left: 0;
}
</style>
